import * as React from "react";
import {
    InAppAdContainer,
    DarkTransparentBackground,
    ImageContainer,
    ModalTitle,
    ContentContainer,
    ConfirmButton,
    CancelButton,
    MadeWithGlide,
} from "./in-app-ad-view-style";
import { getContrastColor } from "common/color-gradient-utils";
import { getLocalizedString } from "common/components/localization";
import { InYourFaceBrandingProps } from "webapp/lib/in-your-face-branding";

interface Props extends InYourFaceBrandingProps {
    onClick: (convert: boolean) => void;
}

export default class InAppAdView extends React.PureComponent<Props> {
    public state = {};

    public render(): React.ReactNode {
        const {
            imageURL,
            color,
            heroTextBeforeBold,
            heroTextBold,
            heroTextAfterBold,
            confirmText,
            cancelText,
            linkURL,
            onClick,
        } = this.props;
        const contrastColor = getContrastColor(color);

        return (
            <>
                <DarkTransparentBackground>
                    <InAppAdContainer bgColor={color}>
                        <ContentContainer>
                            <ImageContainer url={imageURL} />
                            <ModalTitle textColor={contrastColor}>
                                {heroTextBeforeBold}
                                <b>{heroTextBold}</b>
                                {heroTextAfterBold}
                            </ModalTitle>
                            <a href={linkURL} target="_blank" rel="noopener noreferrer" onClick={() => onClick(true)}>
                                <ConfirmButton textColor={color} buttonColor={contrastColor}>
                                    {confirmText}
                                </ConfirmButton>
                            </a>
                            <CancelButton textColor={contrastColor} color={color} onClick={() => onClick(false)}>
                                {cancelText}
                            </CancelButton>
                            <MadeWithGlide textColor={contrastColor}>
                                <a
                                    href={linkURL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => onClick(true)}>
                                    {getLocalizedString("madeWithGlideApps")}
                                </a>
                            </MadeWithGlide>
                        </ContentContainer>
                    </InAppAdContainer>
                </DarkTransparentBackground>
            </>
        );
    }
}
